module.exports = __webpack_public_path__ + "static/img/qrcode.8621eb72.jpg";